/*
Motion bootstrap. The complete specification is in MOTION.md.

Content ships visible. This file adds motion, it never removes content. If it
fails to load, if GSAP 404s, or if the visitor has reduced motion enabled, the
page is a normal static page with nothing stuck at opacity 0.

Sections listed in MOTION.md as "nothing" have no module here on purpose:
client plates, control layer, facts and contact.

Scrolling is the browser's own. Lenis was removed on 26 September 2026, see
MOTION.md, "What makes this page scroll badly".
*/

import '../css/main.css';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { nav } from './nav.js';
import { ground } from './home/ground.js';
import { reveal } from './home/reveal.js';
import { hero } from './home/hero.js';
import { disciplines } from './home/disciplines.js';
import { principles } from './home/principles.js';
import { field } from './home/field.js';
import { insights } from './home/insights.js';

gsap.registerPlugin(ScrollTrigger);

const allowMotion = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/*
The navigation is set up before the motion gate and outside it. Everything below
this line is enhancement and is allowed not to run. A menu is not.
*/
nav();

function refreshOnFontLoad() {
  if (!document.fonts) return;
  document.fonts.ready.then(() => ScrollTrigger.refresh());
}

function start() {
  document.documentElement.classList.add('has-motion');

  const ctx = gsap.context(() => {
    ground(gsap);
    reveal(gsap);
    hero(gsap);
    disciplines(gsap);
    principles(gsap);
    field(gsap);
    insights(gsap);
  });

  refreshOnFontLoad();
  window.addEventListener('beforeunload', () => ctx.revert(), { once: true });
}

if (allowMotion) start();
